document.addEventListener('DOMContentLoaded', () => {
    const coursePreviews = document.querySelectorAll('.course-preview');

    if (!coursePreviews.length) return;

    coursePreviews.forEach(preview => {
        const video = preview.querySelector('.course-tile__video');

        if (!video) return;

        // Play video on hover
        preview.addEventListener('mouseenter', () => {
            video.play().catch(err => console.log('Video play failed:', err));
        });

        // Pause and reset video when hover ends
        preview.addEventListener('mouseleave', () => {
            video.pause();
            video.currentTime = 0;
        });
    });
});